/**
 * Superficie Shell — session layer.
 * Re-exporta únicamente desde `./session/**` para que los consumidores que sólo
 * necesitan símbolos de sesión no arrastren `externalServiceRepo` (→ sync chain)
 * que vive en `./infra-api`. Esto rompe el cluster de require-cycles que pasaba
 * por `shell/public-api`.
 *
 * Named exports only (no `export *`).
 */

export { useSessionStore, defaultPermissions } from './session/store/useSessionStore';
export type { BranchAccess, BranchBarcodeInputMode, BranchPermission, ModuleKey } from './session/store/useSessionStore';

export { useBusinessProfileStore } from './session/store/useBusinessProfileStore';

export { useBranchPermission, resolveBranchModulePermission } from './session/hooks/useBranchPermission';

export { can, useModulePermission, permissionAllowsAction, canModuleAction } from './session/hooks/useModulePermission';

export {
  MODULE_ACTION_CATALOG,
  MAPPED_PERMISSION_ACTIONS,
  RESTRICTIVE_PERMISSION_ACTIONS,
  ACTION_LABEL_ES,
  actionLabelEs,
  customizableActionsForModule,
  isMappedPermissionAction,
  isRestrictivePermissionAction,
} from './session/permissions/permissionCatalog';
export type {
  MappedPermissionAction,
  PermissionAction,
  RestrictivePermissionAction,
} from './session/permissions/permissionCatalog';

export { useHasBusinessCapability, useEffectiveBusinessCapabilities } from './session/hooks/useEffectiveBusinessCapabilities';

export { clearLegacyLocalStockSalePolicy, getStockSalePolicyForBranch, getLocalDataOwnerUserId, setLocalDataOwnerUserId } from './session/settingsRepo';
export type { StockSalePolicy } from './session/settingsRepo';

export {
  SESSION_CACHE_MS,
  CUSTOMER_WEB_REST_CACHE_MS,
  EMPLOYEES_CACHE_MS,
  GLOBAL_FEATURE_FLAGS_CACHE_MS,
  ENTITLEMENTS_CACHE_MS,
  SUPPORT_UNREAD_CACHE_MS,
} from './session/sessionCacheTtl';

export type {
  BusinessTypeCode,
  BusinessTypeListItem,
  OrganizationBusinessProfile,
  UnitOfMeasure,
  BusinessCapability,
} from './session/domain/businessProfile';

export { useBranchBarcodeInputModeForCurrentBranch } from './session/hooks/useBranchBarcodeInputMode';

export { resolveBarcodeInputFlags } from './session/barcodeInputMode';
export type { ResolveBarcodeInputFlagsOptions } from './session/barcodeInputMode';

export { useSyncBranchSettingsOnFocus } from './session/hooks/useSyncBranchSettingsOnFocus';

export {
  clearSessionOrganizationCache,
  primeSessionOrganizationFromEntitlements,
  getSessionOrganizationId,
  requireSessionOrganizationId,
} from './session/sessionOrganization';

export { useSupervisorPinPrompt } from './session/useSupervisorPinPrompt';

export { authorizeSupervisorPin, requireBranchSupervisorPin, branchHasSupervisorPin } from './session/supervisorPinApi';
